import { Button } from '../../buttons'
import styled from 'styled-components'

export const ProductWizardMakeItem = styled.div`
  width: 186px;
  height: 104px;
  border-radius: 12px;
  background-color: ${props => props.theme.color.primary25};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  text-align: center;
  line-height: 48px;
  padding: 5px;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.color.primary100};
  }

  ${props => props.theme.media.mobile`
  width: 124px;
  height: 80px;
`}
`

export const StepFormWrapper = styled.div`
  height: 390px;
  overflow-y: hidden;

  ${props => props.theme.media.mobile`
    overflow-x: hidden;
    width: 300px;
  `}
`

export const ProductWizardModelsContainer = styled.div`
  height: 280px;
  display: flex;
  justify-content: center;
  overflow-y: auto;
`

export const ProductWizardMakeContainer = styled.div`
  height: 325px;
  display: flex;
  justify-content: center;
  overflow-y: auto;

  ${props => props.theme.media.mobile`
    max-width: none;
  `}
`

export const ProductWizardModelsButtonWrapper = styled.div`
  position: sticky;
  top: 0;
  padding-top: 14px;

  ${props => props.theme.media.mobile`
    padding-top: 17px;
  `}
`

export const StepFormStepWizardModelsWrapper = styled.div`
  max-height: 380px;
`

export const HeaderSizeTitle = styled.div`
  padding-top: 12px;
  font-weight: 600;
  padding-bottom: 16px;

  ${props => props.theme.media.mobile`
    padding-bottom: 8px;
  `}
`
export const BattAndReelsTitle = styled(HeaderSizeTitle)`
  padding-top: 0;
`

export const BattAndHeaderButton = styled(Button)`
  width: 186px;
  height: 56px;
  font-size: 16px;

  ${props => props.theme.media.mobile`
    width: 124px;
    height: 48px;
  `}
`

export const BattAndHeaderWrapper = styled.div`
  margin-bottom: 24px;
`

export const ProductWizardHeaderButtonWrapper = styled.div`
  padding-top: 5px;

  ${props => props.theme.media.mobile`
    padding-top: 8px;
  `}
`

export const ProductWizardResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ProductWizardResultTitle = styled.div`
  max-width: 600px;
  display: flex;
  justify-content: center;
  margin-top: 24px;
  font-weight: 600;
  font-size: 18px;

  ${props => props.theme.media.mobile`
    text-align: center;
  `}
`

export const ProductWizardResultPrice = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
`

export const ProductWizardResultQty = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ProductWizardResultQtyLabel = styled.div`
  margin-top: 4px;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
`

export const ProductWizardResultButtonWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ProductWizardResultButton = styled(Button)`
  width: 184px;
  height: 48px;
  margin-top: 30px;

  &:first-child {
    margin-right: 25px;
  }

  &:last-child {
    margin-left: 25px;
  }
`

export const ProductWizardResultContainer = styled.div`
  height: 325px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const ResultButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;

  ${props => props.theme.media.mobile`
    padding-top: 15px;
  `}
`

export const BattAndHeaderContainer = styled.div`
  height: 289px;
  display: flex;
  justify-content: center;
  overflow-y: auto;
`

export const LogoImg = styled.img`
  max-width: 77px;
  max-height: 51px;
`

export const LogoContainer = styled.div`
  display: block;
  height: 50%;
`
